'use client';

import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const PAUSAL_CALCULATOR_URL =
  'https://eporezi.purs.gov.rs/kalkulator-pausalnog-poreza-i-doprinosa.html';
const SIFRARNIK_DELATNOSTI_URL = 'https://knjigovodja.in.rs/sh/sifrarnik-delatnosti';

export default function PausalTaxBanner() {
  const { t } = useLanguage();

  return (
    <section aria-label={t('pausalBanner.aria')} className="py-10 lg:py-12 bg-white">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 lg:gap-8 rounded-2xl border border-slate-200 bg-slate-50/90 px-5 py-5 lg:px-8 lg:py-6">
          <p className="text-slate-700 text-sm lg:text-base leading-relaxed flex-1">
            {t('pausalBanner.text')}{' '}
            <a
              href={SIFRARNIK_DELATNOSTI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-800 underline underline-offset-2 decoration-slate-400 hover:text-slate-950 hover:decoration-slate-600"
            >
              {t('pausalBanner.textInlineLink')}
            </a>
          </p>
          <a
            href={PAUSAL_CALCULATOR_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center justify-center gap-2 shrink-0 whitespace-nowrap self-start sm:self-auto text-sm"
          >
            {t('pausalBanner.button')}
            <ExternalLink size={15} className="opacity-90" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
}
